import { IconLink as TablerIconLink } from '@tabler/icons-react';

import { createOutlineIcon } from '@/components/icon/createOutlineIcon';

export const IconLink = /*#__PURE__*/ createOutlineIcon(TablerIconLink, 'IconLink');
